import * as React from "react";
import {
  Create,
  SimpleForm,
  required,
  SelectInput,
  TextInput,
} from "react-admin";
import { PUSH_NOTIFICATION_SERVICES_STATUSES } from "@local/constants/index.js";
import { CustomToolbar } from "../../shared/components/index.js";
import { JsonInput } from "react-admin-json-view";

const createPushNotificationService = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextInput
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
        inputProps={{ maxLength: 255 }}
        source="name"
        validate={[required()]}
      />
      <JsonInput
        validate={[required()]}
        source="config"
        label="resources.PushNotificationService.fields.config.name"
        reactJsonOptions={{
          name: null,
          collapsed: false,
          enableClipboard: false,
          displayDataTypes: false,
        }}
      />
      <SelectInput
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
        source="status"
        validate={[required()]}
        choices={Object.keys(PUSH_NOTIFICATION_SERVICES_STATUSES).map(
          (status) => ({
            id: status,
            name: `resources.PushNotificationService.source.status.${status}`,
          })
        )}
      />
    </SimpleForm>
  </Create>
);

export default createPushNotificationService;
